import React, { useEffect, useState } from "react";
import "./DashboardBox.css";

import {
  IoCubeOutline,
  IoScanSharp,
  IoBarcodeOutline,
  IoDocumentsOutline,
  IoPeopleOutline,
  IoSkullOutline,
  IoWarningOutline,
  IoBagAddOutline,
} from "react-icons/io5";

import { RiFileDamageLine } from "react-icons/ri";

import { GiThermometerCold } from "react-icons/gi";
import { BsTruck } from "react-icons/bs";
import { HiCursorClick } from "react-icons/hi";

export default function DashboardBox(props) {
  const [clickActive, setClickActive] = useState(false);
  // const [freeActive, setFreeActive] = useState(false);

  useEffect(() => {
    // if (!props.clickable) {
    //   props.onClick &&
    //   props.name !== "Total Orders" &&
    //   props.name !== "Admin Picker Available" &&
    //   props.name !== "Picked" &&
    //   props.name !== "Missing Med"
    //     ? setClickActive(true)
    //     : setClickActive(false);
    // } else
    if (props.clickable) {
      props.onClick ? setClickActive(true) : setClickActive(false);
    }
  });
  return (
    <React.Fragment>
      <div
        className={`dashboardBox ${
          props.activeBox === props.name ? "active" : ""
        }`}
        onClick={() =>
          props.name === "Free Pickers Available" && clickActive
            ? props.onClick(!props.toggleClick)
            : props.name === "Free Checkers Available" && clickActive
            ? props.onClick(!props.toggleClick)
            : clickActive
            ? props.onClick(props.name)
            : null
        }
      >
        {/* Conditional Icons rendering accroding type */}
        <div className="dashboardBox_icon">
          {props.type === "pick" ? (
            <IoCubeOutline />
          ) : props.type === "picker" ? (
            <IoPeopleOutline />
          ) : props.type === "unassigned" ? (
            <IoDocumentsOutline />
          ) : props.type === "missingMed" ? (
            <IoBagAddOutline />
          ) : props.type === "expired" ? (
            <IoWarningOutline />
          ) : props.type === "damage" ? (
            <RiFileDamageLine />
          ) : props.type === "cold" ? (
            <GiThermometerCold />
          ) : props.type === "dispatch" ? (
            <BsTruck />
          ) : (
            <IoBarcodeOutline />
          )}
        </div>

        {clickActive && (
          <div className="clickableIcon">
            <HiCursorClick />
          </div>
        )}

        <div className="dashboardBox_info">
          <p>{props.name}</p>
          {props.totalCount ? (
            <h2>
              {props.count}
              &nbsp;
              <br />
              <span style={{ marginTop: "5px" }}>
                {props.subName} - {props.totalCount ? props.totalCount : 0}
              </span>
            </h2>
          ) : (
            <h2>{props.count ? props.count : "0"}</h2>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}
